import { render, staticRenderFns } from "./associateUserPage.vue?vue&type=template&id=33040378&"
import script from "./associateUserPage.vue?vue&type=script&lang=js&"
export * from "./associateUserPage.vue?vue&type=script&lang=js&"
import style0 from "./associateUserPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports